import React, { useState } from 'react';

import { useDispatch } from 'react-redux';

import Button from 'common-ui/button';
import Input from 'common-ui/input';
import Modal from 'common-ui/modal';
import CustomSelectComponent from 'common-ui/select/Select';
import { updateLead } from 'features/newsales/newsalesActions';
import { notifyError } from 'utils/notifyConfig';

const INTERCOM_OPTIONS = [
  { value: 'yes', label: 'Yes' },
  { value: 'no', label: 'No' },
];

const SetAppointmentModal = ({ isOpen, onClose, leadData, onSaved }) => {
  const dispatch = useDispatch();
  const [intercomHandset, setIntercomHandset] = useState(null);
  const [entrance, setEntrance] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const needsEntrance = !leadData?.entrance;
  const isValid = intercomHandset !== null && (!needsEntrance || entrance.trim() !== '');

  const handleSubmit = async () => {
    if (!isValid || isLoading) return;

    setIsLoading(true);
    try {
      const payload = { intercomHandset: intercomHandset.value };
      if (needsEntrance) payload.entrance = entrance;

      await dispatch(updateLead({ leadId: leadData.id, leadData: payload })).unwrap();
      handleClose();
      onSaved();
    } catch (err) {
      notifyError(err?.message || 'Failed to update lead');
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    setIntercomHandset(null);
    setEntrance('');
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} title="Fill in the Missing Details" closeIcon>
      <CustomSelectComponent
        options={INTERCOM_OPTIONS}
        value={intercomHandset}
        onChange={setIntercomHandset}
        label="Intercom Handset"
        placeholder="Select..."
        isSearchable={false}
      />

      {needsEntrance && (
        <Input
          type="text"
          label="Entrance"
          placeholder="Enter entrance"
          value={entrance}
          onChange={(e) => setEntrance(e.target.value)}
        />
      )}

      <Button
        secondary
        onClick={handleSubmit}
        loading={isLoading}
        disabled={!isValid || isLoading}
      >
        Confirm
      </Button>
    </Modal>
  );
};

export default SetAppointmentModal;
